module.exports = "//public.zight.com/packs/media/images/about-3b148c7a022ea743a3507f9a80867c64.png";